import React, { useState } from 'react';

import { ICONS } from '../../../icons';
import CommonIconButton from '../../../components/common-icon-button/CommonIconButton';
import scss from './SonarDashboardHeader.module.scss';
import LabelSettingsModal from './label-settings-modal/LabelSettingsModal';

function SonarSettings() {
  const [isSettingsOpen, setIsSettingsOpen] = useState(false);

  const handleOpenSettings = () => {
    setIsSettingsOpen(true);
  };

  const handleCloseSettings = () => {
    setIsSettingsOpen(false);
  };

  return (
    <div className={scss.settingsIcon}>
      <CommonIconButton icon={ICONS.Settings} onClick={handleOpenSettings} isStrokeIcon />

      <LabelSettingsModal
        isOpen={isSettingsOpen}
        onCancel={handleCloseSettings}
        onClose={handleCloseSettings}
        onSubmit={() => null}
      />
    </div>
  );
}

export default SonarSettings;
